import { render, staticRenderFns } from "./FlightSalesReport.vue?vue&type=template&id=60509882"
import script from "./FlightSalesReport.vue?vue&type=script&lang=js"
export * from "./FlightSalesReport.vue?vue&type=script&lang=js"
import style0 from "./FlightSalesReport.vue?vue&type=style&index=0&id=60509882&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports